import { useMemo } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { DATE_FORMAT_BY_LOCALE } from 'interfaces/constants/pregenancyCategory'

export const TimeBar = ({ date, ...boxProps }: { date?: Date } & BoxProps) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()
  const dateObj = useMemo(() => dayjs(date), [date])
  // const dateObj = dayjs('2024-05-14') //for test

  return date ? (
    <Box {...boxProps}>
      <Text size="s4" sx={{ padding: `4px 12px` }}>
        {dateObj.isBefore(dayjs().subtract(1, 'week'))
          ? dateObj.format(DATE_FORMAT_BY_LOCALE[locale])
          : dateObj.isSame(dayjs().subtract(1, 'day'), 'day')
          ? f({ id: 'searchPage.yesterday' })
          : dateObj.isSame(dayjs(), 'day')
          ? f({ id: 'searchPage.today' })
          : dateObj.format('dddd')}{' '}
        {dateObj.format('HH:mm')}
      </Text>
    </Box>
  ) : null
}
